var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3586 20.972L19.5708 2.35514C18.723 0.882243 17.2001 0 15.4972 0C13.7942 0 12.2713 0.874766 11.4236 2.34766L0.635792 20.9645C-0.21193 22.4299 -0.21193 24.1869 0.635792 25.6523C1.48351 27.1178 3.00641 28 4.70936 28H26.285C27.988 28 29.5109 27.1252 30.3586 25.6523C31.2138 24.1869 31.2138 22.4374 30.3586 20.972ZM15.4972 23.1551C14.4544 23.1551 13.6067 22.3103 13.6067 21.271C13.6067 20.2318 14.4544 19.3869 15.4972 19.3869C16.54 19.3869 17.3877 20.2318 17.3877 21.271C17.3877 22.3103 16.54 23.1551 15.4972 23.1551ZM17.3877 16.3589C17.3877 17.3981 16.54 18.243 15.4972 18.243C14.4544 18.243 13.6067 17.3981 13.6067 16.3589V7.76075C13.6067 6.7215 14.4544 5.87664 15.4972 5.87664C16.54 5.87664 17.3877 6.7215 17.3877 7.76075V16.3589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.7ba7416068ce04eb8b534cc29785f862.svg";
export { ForwardRef as ReactComponent };